import { NavController, ViewController, AlertController, LoadingController, Platform } from 'ionic-angular';
import { Component } from '@angular/core';
import { TabsPage } from '../tabs/tabs';
import { UserService } from '../../services/user.services';
import { AppConfigService } from '../../services/appConfig.service';
import { AppDialog } from "../../component/appDialog";
import { Splashscreen } from 'ionic-native';
import { AppConfig } from "../../util/appConfig";
import { Base64Util } from "../../util/base64Util";
import { Keyboard } from 'ionic-native';
import { ServicePage } from "../service/service";
import { ImproveUserPage } from "../improveUser/improveUser";
import { SpeedTestPage } from "../speedTest/speedTest";
import { UserEditPage } from "../userEdit/userEdit";
import { UserPage } from "../user/user";

import { CommonService } from "../../services/common.service";
import { TranslateService } from 'ng2-translate';

@Component({
    templateUrl: 'login.html',
    selector: 'login-page',
})
export class LoginPage {
    un: string = '';
    pwd: string = '';
    version: string;
    serveApi: string = "";
    isSaveInfo: boolean;
    base64Util: any;
    serverName: string;
    serverList: any = [];
    speedTest: boolean;
    isAutoLogin = false;
    isCordova: boolean = false;
    linkDownApp: string = '';
    static vndTitle :string = 'VND';
    static userID: number;
    static cytype: number; //0 = vndk , 1 vnd
    static cyName: string; //0 = vndk , 1 vnd
    static wallettype: number; //0 = vndk , 1 vnd
    static paramUserLogin: any = '';
    static paramGameInfo: any = '';
    public selectedLanguage: string = 'vi';
    private downURLIOS: string = "";
    private downURLAndroid: string = "";
    passwordType: string = 'password';
    passwordIcon: string = 'eye-off';
    // private un: string = 'yuwu188';
    // private pwd: string = '123qwe';
    constructor(private viewCtrl: ViewController, 
        private translate: TranslateService,
        private userService: UserService,
        private nav: NavController,
        private common: CommonService,
        private alertCtrl: AlertController, public loadingCtrl: LoadingController,
        private platform: Platform, public cs: CommonService) {
        Keyboard.hideKeyboardAccessoryBar(false);
        this.base64Util = new Base64Util();
        if (localStorage.getItem("save") == "true") {
            this.isSaveInfo = true;
            this.un = this.base64Util.decode(localStorage.getItem("u"));
            this.pwd = this.base64Util.decode(localStorage.getItem("p"));
        }
        //this.checkVersion();

        const storedLanguage = localStorage.getItem('langcode');
        if (storedLanguage) {
            this.selectedLanguage = storedLanguage;
        } else {
            this.selectedLanguage = 'vi'; // Mặc định là tiếng Anh nếu không có giá trị trong localStorage
        }

        this.speedTest = true;
        //this.getServerList();
        if (window.hasOwnProperty("serveApi")) {
            // this.speedTest = true;
            // this.getServerList();
            Splashscreen.hide();
            this.serveApi = window["serveApi"] + "images/download";
        } else {
            this.serveApi = "images/download";
        }
        if (document.getElementById("progress-pie-chart")) {
            clearInterval(window["sysLoaing"]);
            let progId = document.getElementById("progress-pie-chart");
            progId.parentNode.removeChild(progId);
            let progText = document.getElementById("progress-text");
            progText.parentNode.removeChild(progText);
        }

        if (this.platform.is('core') || this.platform.is('mobileweb')) {
            this.isCordova = true;
            let urlGetApp = "";
            if (this.platform["_versions"].hasOwnProperty('android')) {
                urlGetApp = 'https://down.lt188.co/apk/android-down.html';
            } else if (this.platform["_versions"].hasOwnProperty('ios')) {
                urlGetApp = 'https://down.lt188.co/ipa/ios-down.html';
            }
            this.linkDownApp = urlGetApp;
        }

        this.version = AppConfig.Version;

        let queryString = window.location.search;
        if (queryString == "") {
            return;
        }
        let urlParams = new URLSearchParams(queryString);
        // let userName = this.base64Util.decode(urlParams.get('?username'));
        let token = urlParams.get('token');
        if (token) {
            this.isAutoLogin = true
        } else {
            this.isAutoLogin = false
        }
        token = this.base64Util.decode(urlParams.get('token'));
        let userName = token.split("&")[1];
        let pwd = token.split("&")[2];
        let lotteryId = urlParams.get('gameId');
        let lang = token.split("&")[3] || "vi"; 
        console.log('====================================');
        console.log('lang',lang);
        console.log('====================================');
        this.selectedLanguage = lang;
        
        this.common.languageChange(this.selectedLanguage);
        const storedLanguage2 = localStorage.getItem('langcode');
        if (storedLanguage) {
            this.selectedLanguage = storedLanguage2;
        }

        let user = {
            un: userName,
            pwd: pwd,
            ver: AppConfig.Version,
            gameid:lotteryId,
            lang: lang
        };
        this.userService.login(user, this).then(data => {
            if (data["msg"] == "") {
                //console.log("data==" + JSON.stringify(data) );
                LoginPage.userID = data['user'].id;
                
                LoginPage.cytype = data['agentDto'].cytype;
                LoginPage.cyName = data['cyname'];
                LoginPage.wallettype = data['agentDto'].wallettype;
                LoginPage.vndTitle = data['cyname']
                this.cs.userType = data['user'].usertype;
                this.cs.username = this.base64Util.encode(this.un);
                this.cs.password = this.base64Util.encode(this.pwd);

                localStorage.removeItem("tu");
                localStorage.removeItem("tp");
                if (this.cs.userType > 1) {
                    localStorage.setItem("tu", this.base64Util.encode(this.un));
                    localStorage.setItem("tp", this.base64Util.encode(this.pwd));
                }

                AppConfigService.sid = data["SessionId"];
                if (this.isSaveInfo) {
                    localStorage.setItem("save", "true");
                    localStorage.setItem("u", this.base64Util.encode(this.un));
                    localStorage.setItem("p", this.base64Util.encode(this.pwd));
                } else {
                    localStorage.setItem("save", "false");
                    localStorage.removeItem("u");
                    localStorage.removeItem("p");
                }

                LoginPage.paramUserLogin = data["user"];
                //gameif
                if(data["gameInfo"] != null) {
                    LoginPage.paramGameInfo = data["gameInfo"];
                }
                
                console.log('====================================');
                console.log('LoginPage.paramGameInfo',LoginPage.paramGameInfo);
                console.log('====================================');
                /* this.nav.push(TabsPage, {
                     paramUser: data["user"],
                 //viewType: viewType
                 }).then(() => {
                     let index = this.viewCtrl.index;
                     this.nav.remove(index);
                 });*/
                 this.nav.push(TabsPage, {},{animate:false}).then(() => {
                    let index = this.viewCtrl.index;
                    this.nav.remove(index);
                });
                    //update theme theo user
                if(data['themeid'] != undefined) {
                    this.setTheme(data['themeid']);
                }
                
            } else {
                if (data["msg"] == "-1") {
                    this.nav.push(ImproveUserPage, {
                        paramUser: data["user"],
                    });
                } else {
                    AppDialog.alert({
                        alertCtrl: this.alertCtrl,
                        message: data["msg"]
                    });
                }
            }
        });

      
    }

    
    onLanguageChange(event) {
        this.common.languageChange(this.selectedLanguage);
      }

    getServerList() {
        this.userService.getServerList({}, this.alertCtrl).then(data => {
            this.serverList = data;
            if (window.hasOwnProperty("serveApi")) {
                let apiURL = localStorage.getItem("apiURL");
                let serverName = localStorage.getItem("serverName");
                let found = false;
                for (let server of this.serverList) {
                    if (server.name == serverName && server.url == apiURL) {
                        found = true;
                        break;
                    }
                }
                if (found) {
                    window["serveApi"] = apiURL;
                } else {
                    localStorage.removeItem("apiURL");
                    localStorage.removeItem("serverName");
                    for (let server of this.serverList) {
                        if (server.url == window["serveApi"]) {
                            this.serverName = server.name;
                            localStorage.setItem("serverName", this.serverName);
                            break;
                        }
                    }
                }
            } else {
                // WAP
                for (let server of this.serverList) {
                    if (server.url == window.location.href) {
                        this.serverName = server.name;
                        localStorage.setItem("serverName", this.serverName);
                        break;
                    }
                }
            }


        });
    }

    checkVersion() {
        this.userService.checkVersion({}, this.alertCtrl).then(data => {
            if (window.hasOwnProperty("serveApi")) {
                if (this.platform.platforms().indexOf("ios") > 0) {
                    if (data["iosversionid"] != AppConfig.Version) {
                        this.update(data["flag"], data["iosURL"]);
                        this.downURLIOS = data["iosURL"];
                    }
                } else {
                    if (data["androidversionid"] != AppConfig.Version) {
                        this.update(data["flag"], data["androidURL"]);
                        this.downURLAndroid = data["androidURL"];
                    }
                }
            }
            localStorage.setItem("onlineURL", data["onlineURL"]);
        });
    }

    update(flag: string, downUrl: string) {
        if (flag == "no") {
            let alertCmp = this.alertCtrl.create({
                subTitle: 'Đã có phiên bản mới, bạn có muốn cập nhật?',
                buttons: [
                    {
                        text: 'Bỏ qua'
                    },
                    {
                        text: 'Cập nhật',
                        handler: () => {
                            location.href = downUrl;
                        }
                    }
                ]
            });
            alertCmp.present();
        } else {
            let alertCmp = this.alertCtrl.create({
                subTitle: "Đã có phiên bản mới, vui lòng cập nhật!",
                buttons: [
                    {
                        text: 'Cập nhật',
                        handler: () => {
                            location.href = downUrl;
                        }
                    }
                ]
            });
            alertCmp.present();
        }
    }

    loginFn() {
        let user = {
            un: this.un.toLowerCase().trim(),
            pwd: this.pwd,
            lang: this.selectedLanguage,
            ver: AppConfig.Version
        };
        this.userService.login(user, this).then(data => {
            
            if (data["msg"] == "") {
                LoginPage.userID = data['user'].id;
                LoginPage.cytype = data['agentDto'].cytype;
                LoginPage.cyName = data['cyname'];
                LoginPage.wallettype = data['agentDto'].wallettype;
                LoginPage.vndTitle = data['cyname'];
                this.cs.userType = data['user'].usertype;
                this.cs.username = this.base64Util.encode(this.un);
                this.cs.userNameFull = this.un;
                this.cs.password = this.base64Util.encode(this.pwd);

                localStorage.removeItem("tu");
                localStorage.removeItem("tp");
                if (this.cs.userType > 1) {
                    localStorage.setItem("tu", this.base64Util.encode(this.un));
                    localStorage.setItem("tp", this.base64Util.encode(this.pwd));
                }

                AppConfigService.sid = data["SessionId"];
                if (this.isSaveInfo) {
                    localStorage.setItem("save", "true");
                    localStorage.setItem("u", this.base64Util.encode(this.un));
                    localStorage.setItem("p", this.base64Util.encode(this.pwd));
                } else {
                    localStorage.setItem("save", "false");
                    localStorage.removeItem("u");
                    localStorage.removeItem("p");
                }

                LoginPage.paramUserLogin = data["user"];
                
                this.nav.push(TabsPage, {},{animate:false}).then(() => {
                    let index = this.viewCtrl.index;
                    this.nav.remove(index);
                });

                // if(LoginPage.cytype == 0) {
                //     LoginPage.vndTitle = 'VNDK'
                // }else{
                //     LoginPage.vndTitle = 'VND'
                // }
                
                //update theme theo user
                if(data['themeid'] != undefined) {
                    this.setTheme(data['themeid']);
                }
                
            } else {
                if (data["msg"] == "-1") {
                    this.nav.push(ImproveUserPage, {
                        paramUser: data["user"]
                    });
                } else if (data["msg"] === "-2") {
                    let alertCmp = this.alertCtrl.create({
                        subTitle: this.translate.instant('NEW_VERSION_UPDATE'),
                        buttons: [
                          {
                            text: this.translate.instant('UPDATE'),
                            handler: () => {
                              location.href = this.platform.platforms().indexOf("ios") > 0 ? this.downURLIOS : this.downURLAndroid;
                            }
                          }
                        ]
                      });
                      alertCmp.present();
                } else {
                    AppDialog.alert({
                        alertCtrl: this.alertCtrl,
                        message: data["msg"]
                    });
                }
            }
        });
    }

    contact() {
        this.nav.push(ServicePage);
    }

    speedtest() {
        this.nav.push(SpeedTestPage, {
            serverList: this.serverList
        });
    };

    ionViewWillLeave() {
        Keyboard.close();
    }

    ionViewWillEnter() {
        this.serverName = localStorage.getItem("serverName");
    }
    hideShowPassword() {
        this.passwordType = this.passwordType === 'text' ? 'password' : 'text';
        this.passwordIcon = this.passwordIcon === 'eye-off' ? 'eye' : 'eye-off';
    }


    clearPassword() {
        this.pwd = '';
    }


    setTheme(theme: string) {
        const body = document.body;
    
        // Remove any existing theme class
        body.classList.remove( 'loto188');
    
        // Add new theme class
        if (theme === 'loto188') {
          body.classList.add('loto188');
        } else {
          body.classList.add('theme-default');
        }
      }

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts